
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/department/[...slug]",
      function () {
        return require("private-next-pages/department/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/department/[...slug]"])
      });
    }
  